<template>
  <div>
    <v-timeline dense>
        <v-timeline-item v-if="getStatusTimeline == 0" color="ligth red" small><strong style="white-space: nowrap;">En Carga</strong></v-timeline-item>
        <v-timeline-item v-else color="ligth grey" small><strong style="white-space: nowrap;">En Carga</strong></v-timeline-item>
         <v-timeline-item v-if="getStatusTimeline == 3" color="ligth red" small><strong>Devuelto</strong></v-timeline-item>
        <v-timeline-item v-else  color="ligth grey" small><strong>Devuelto</strong></v-timeline-item>
        <v-timeline-item v-if="getStatusTimeline == 1" color="ligth yellow" small><strong>Presentado</strong></v-timeline-item>
        <v-timeline-item v-else  color="ligth grey" small><strong>Presentado</strong></v-timeline-item>
        <v-timeline-item v-if="getStatusTimeline == 2" color="ligth green" small><strong>Aprobado</strong></v-timeline-item>
        <v-timeline-item v-else  color="ligth grey" small><strong>Aprobado</strong></v-timeline-item>
    </v-timeline>
  </div>
</template>
<script>
export default {
  props: {
    status: Number
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    getStatusTimeline () {
      return this.status
    }
  }
}
</script>
